import { CART_ORDER_LC } from '@/const/localStorage'
import store from '@/store/index'
import Utils from './Utils'
const cardUtils = {
    setLcCart(val: any) {
        const raw = localStorage.getItem(CART_ORDER_LC)
        let cart: any[] = []

        try {
            cart = raw ? JSON.parse(raw) : []
        } catch (e) {
            cart = []
        }

        const index = cart.findIndex(item => item.productId === val.productId)

        if (index !== -1) {
            // Ghi đè sản phẩm
            cart[index] = {
                ...cart[index],
                ...val,
                quantity: val.quantity ?? 1,
                priceUse: (val.priceUse) * (val.quantity ?? 1)
            }
        } else {
            cart.push({
                ...val,
                quantity: val.quantity ?? 1,
                priceUse: (val.priceUse) * (val.quantity ?? 1)
            })
        }

        localStorage.setItem(CART_ORDER_LC, JSON.stringify(cart))
        this.setLoadCart()
    },

    setLoadCart() {
        store.dispatch('setLoadCart', Utils.randomText(5))
    },
    getLcCart() {
        let dataOrder = localStorage.getItem(CART_ORDER_LC)
        if (dataOrder != null && dataOrder != undefined) {
            return this.parseStringToArray(dataOrder).reverse()
        } else {
            return []
        }
    },
    parseStringToArray(val: any) {
        return JSON.parse(val.replace(/'/g, '"'))
    },
    setLcOrderChange(val: any) {
        let dataCart = []
        let dataOrder = localStorage.getItem(CART_ORDER_LC)
        if (dataOrder != null && dataOrder != undefined && dataOrder.length > 10) {
            let dataOld = this.parseStringToArray(dataOrder)
            dataCart = dataOld
            for (let i = 0; i < dataOld.length; i++) {
                let item = dataOld[i].id
                let valId = val.id
                if (item == valId) {
                    dataCart[i].quantity = val.quantity
                    dataCart[i].priceUse = (dataCart[i].price - dataCart[i].priceDiff) * val.quantity
                }
            }

        }

        localStorage.setItem(CART_ORDER_LC, JSON.stringify(dataCart))
        this.setLoadCart()
    },
    removeLcCart(val: any) {
        let dataCart = []
        let dataOrder = localStorage.getItem(CART_ORDER_LC)
        if (dataOrder != null && dataOrder != undefined) {
            let dataOld = this.parseStringToArray(dataOrder)
            dataCart = dataOld
            for (let i = 0; i < dataOld.length; i++) {
                let item = dataOld[i].productId
                if (item == val) {
                    dataCart.splice(i, 1)
                }
            }
        }
        localStorage.setItem(CART_ORDER_LC, JSON.stringify(dataCart))
        this.setLoadCart()
    },
}
export default cardUtils